<form
  [formGroup]="zonedDateRangeForm"
  [ngbTooltip]="readonly ? notAuthorized : false"
  >
  <div class="row row-cols-auto g-1 mb-2">
    <label
      class="fw-normal col-12 col-sm-2 col-l-1 col-form-label-sm"
      i18n
    >From</label>
    <div class="col row row-cols-auto g-1 align-items-center">
      <div class="col">
        <div class="input-group input-group-sm">
          <input
            required
            [readonly]="readonly || isDateRangeJoined"
            #picker0="ngbDatepicker"
            #dateInput
            [placeholder]="(dateFormat | uppercase)"
            ngbDatepicker
            [minDate]="_minDateAsNgb"
            [maxDate]="_maxDateAsNgb"
            formControlName="start"
            class="form-control form-control-sm"
            type="text"
            />
          <div class="input-group-append">
            <button
              class="btn btn-sm btn-light"
              [disabled]="readonly || isDateRangeJoined"
              (click)="picker0.toggle()"
              type="button"
              >
              <svg-icon
                name="calendar-choice"
                [svgStyle]="{'height.pc':1,'width.pc':1}"
              ></svg-icon>
            </button>
          </div>
        </div>
      </div>
      @if (enableJoinedDateBehavior) {
        <div
          class="col"
          >
          <input
            [(ngModel)]="isDateRangeJoined"
            [ngModelOptions]="{standalone: true}"
            [disabled]="readonly"
            (change)="joinDateRange()"
            type="checkbox"
            class="btn-check"
            [id]="joinDateRangeCheckBoxId"
            />
          <label
            class="btn btn-sm btn-light"
            [for]="joinDateRangeCheckBoxId"
            >
            <fa-icon icon="anchor"></fa-icon>
          </label>
        </div>
      }
    </div>
  </div>
  <div class="row row-cols-auto g-1 align-items-center">
    <label
      class="fw-normal col-12 col-sm-2 col-l-1 col-form-label-sm"
      i18n
    >To</label>
    <div class="col">
      <div class="input-group input-group-sm">
        <input
          required
          [readonly]="readonly"
          #picker1="ngbDatepicker"
          #dateInput
          [placeholder]="(dateFormat | uppercase)"
          ngbDatepicker
          [minDate]="_minDateAsNgb"
          [maxDate]="_maxDateAsNgb"
          formControlName="end"
          class="form-control form-control-sm"
          type="text"
          />
        <div class="input-group-append">
          <button
            class="btn btn-sm btn-light"
            [disabled]="readonly"
            (click)="picker1.toggle()"
            type="button"
            >
            <svg-icon
              name="calendar-choice"
              [svgStyle]="{'height.pc':1,'width.pc':1}"
            ></svg-icon>
          </button>
        </div>
      </div>
    </div>
    <!-- NOW BUTTON -->
    <div class="col">
      <button
        class="btn btn-sm btn-light"
        [disabled]="readonly"
        i18n-ngbTooltip
        ngbTooltip="Now"
        (click)="setDateToNow()"
        >
        <svg-icon
          name="calendar"
          [svgStyle]="{'height.pc':1,'width.pc':1}"
        ></svg-icon>
      </button>
    </div>
  </div>
</form>
<ng-template
  #notAuthorized
  i18n
>Not authorized</ng-template>